var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return Object.keys(_vm.socialMediaItems).length ? _c('div', {
    staticClass: "flex items-center",
    class: {
      'justify-center': _vm.center
    }
  }, [_vm._l(_vm.socialMediaItems, function (socialMediaValue, socialMediaIndex) {
    return [socialMediaValue.url ? _c('tooltip', {
      key: 'social-media-' + socialMediaIndex,
      class: {
        'ml-8': socialMediaIndex !== 0,
        'mr-8': socialMediaIndex !== _vm.socialMediaItems.length - 1
      },
      attrs: {
        "text": socialMediaValue.name
      }
    }, [_c('a', {
      staticClass: "text-2xl text-gray-400",
      class: {
        'text-facebook': socialMediaValue.type === 'facebook',
        'text-instagram': socialMediaValue.type === 'instagram',
        'text-youtube': socialMediaValue.type === 'youtube',
        'text-twitter': socialMediaValue.type === 'twitter',
        'text-whatsapp': socialMediaValue.type === 'whatsapp',
        'text-telegram': socialMediaValue.type === 'telegram'
      },
      attrs: {
        "href": socialMediaValue.url,
        "target": "_blank",
        "rel": "noopener",
        "aria-label": socialMediaValue.name
      }
    }, [_c('icon', {
      attrs: {
        "large": "",
        "icon": _vm.icons[socialMediaValue.type]
      }
    })], 1)]) : _vm._e()];
  })], 2) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }